/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import { Component } from '@angular/core';

/**
 * Loading mask component with Angular.
 */
@Component({
    selector: 'fc-ag-loading-mask',
    templateUrl: './fc-ag-loading-mask.component.html',
    styleUrls: ['./fc-ag-loading-mask.component.scss']
})
export class FcAgLoadingMaskComponent {

    /**
     * FcAgLoadingMaskComponent constructor.
     */
    constructor() {
    }
}
